import { isSameAuthRequestSession } from '@/utils/account-disabled-session';

/** One refresh per session. Never replay a request after that session changes or is disabled. */
export function createAuthRequestRecovery({
  getSession,
  refresh,
  invalidateSession,
  handleAccountDisabled,
  retry,
}) {
  let activeRefresh = null;

  function assertCurrent(session) {
    if (isSameAuthRequestSession(session, getSession())) return;
    const error = new Error('Authentication session changed');
    error.authFeedbackHandled = true;
    throw error;
  }

  return async function recover(config) {
    const session = config.__authSession;
    assertCurrent(session);
    config._retried = true;
    if (!activeRefresh || !isSameAuthRequestSession(session, activeRefresh.session)) {
      const entry = { session, promise: null };
      entry.promise = Promise.resolve()
        .then(() => {
          assertCurrent(session);
          return refresh(session);
        })
        .catch((error) => {
          if (!handleAccountDisabled(error, session)) {
            if (isSameAuthRequestSession(session, getSession())) invalidateSession();
          }
          throw error;
        })
        .finally(() => {
          if (activeRefresh === entry) activeRefresh = null;
        });
      activeRefresh = entry;
    }
    const token = await activeRefresh.promise;
    assertCurrent(session);
    config.headers.Authorization = token;
    return retry(config);
  };
}
